/* Angular Libraries */
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./modules/account/account.module').then(m => m.AccountModule)
  },
  {
    path: '',
    loadChildren: () => import('./modules/account/account.module').then(m => m.AccountModule)
    //path: '',
    //pathMatch: 'full',
    //redirectTo: 'login'
  },
  //{
  //  path: '**',
  //  pathMatch: 'full',
  //  redirectTo: 'error/404'
  //}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {enableTracing: false})],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
